module.exports = __webpack_public_path__ + "static/img/energy-trust.c90211e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy-trust.png
// module id = Jvcf
// module chunks = 0